export default function FigureTile({ name, portrait, alt, className }) {
  console.log("FigureTile", name, portrait, alt, className);
  return (
    <div className={`bg-white p-2 xl:p-3 ${className}`} style={{ direction: "ltr" }}>
      <img src={portrait} width="150px" height="250px" alt={alt ?? ""} />
      <div className="text-extraTiny xl:text-tiny font-bold uppercase mt-2">
        {name} {portrait.caption}{" "}
        <span className="text-extraTiny text-gray-500">{alt}</span>
      </div>
    </div>
  );
}
